import { BaseEnum } from "../../../enums/baseEnum"

// As tres categorias (task #216) compartilham tabela e tela de gestao, cada uma com seu proprio seletor.
const listRecruitProcessReasonTypeEnum: Array<RecruitProcessReasonType> = [];

export class RecruitProcessReasonType extends BaseEnum {
  static REJECTION = new RecruitProcessReasonType(1, 'REJECTION', 'Reprovação de candidato(a)', 'danger');
  static RECRUITMENT_PAUSE = new RecruitProcessReasonType(2, 'RECRUITMENT_PAUSE', 'Pausa de vaga', 'warning');
  static RECRUITMENT_REOPEN = new RecruitProcessReasonType(3, 'RECRUITMENT_REOPEN', 'Reabertura de vaga', 'info');
  static CANDIDATE_WITHDRAWAL = new RecruitProcessReasonType(4, 'CANDIDATE_WITHDRAWAL', 'Desistência do candidato(a)', 'warning');

  constructor(public id: number, public value: string, public label: string, public className: string) {
    super(id, value, label, className)
    listRecruitProcessReasonTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listRecruitProcessReasonTypeEnum;
  }

  // O backend as vezes serializa o enum como numero (2), as vezes como nome PascalCase
  // ("RecruitmentPause"), dependendo do pipeline que atende a rota. Normaliza para numero.
  public static normalizeId(raw: number | string | null | undefined): number | null {
    if (raw === null || raw === undefined || raw === '') {
      return null;
    }
    if (typeof raw === 'number') {
      return raw;
    }
    const asNumber = Number(raw);
    if (!Number.isNaN(asNumber)) {
      return asNumber;
    }
    const normalized = raw.replace(/_/g, '').toLowerCase();
    const byName = listRecruitProcessReasonTypeEnum.find(
      (t) => t.value.replace(/_/g, '').toLowerCase() === normalized
    );
    return byName ? byName.id : null;
  }
}
